import { ReceiptStatus } from "@dune/vars";


export const getReceiptStatusLabel = (status: ReceiptStatus) => {
	switch (status) {
		case "PENDING":
			return "A régler";
		case "PAID":
			return "Réglée";
		case "REFUNDED":
			return "Remboursé";
		case "CANCELLED":
			return "Annulé";
		default:
			return status;
	}
};

export const getTypeLabel = (type: string) => {
	switch (type) {
		case "NEW_BUSINESS":
			return "AFN";
		case "AMENDMENT":
			return "AVT";
		case "CANCELLATION":
			return "ANNUL";
		default:
			return type;
	}
};

export const getProductTypeLabel = (productType: string) => {
	switch (productType) {
		case "DO":
			return "DO";
		case "TRC":
			return "TRC";
		case "MRT":
			return "MRT";
		default:
			return productType;
	}
};
